// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme/default-theme';
import { HighlightBox } from '@tectonics/look-and-feel/uber-v2/atoms';

export const VoucherTicket = styled(HighlightBox)`
  font-family: ${theme.fontFamily.display};
  display: flex;
  flex-direction: column;
  padding: 6px;
  border-radius: 5px;
  &:empty {
    display: none;
  }
  @media (${theme.device.sm}) {
    flex-direction: row;
  }
`;

export function Cell({ children }: { children: Node }): Node {
  return (
    <CellWrap>
      <CellCenter>{children}</CellCenter>
    </CellWrap>
  );
}

export const CellWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid hsla(240,8%,50%,0.15);
  padding: 12px;
  color: hsla(0,0%,40%,1);
  font-family: ${theme.fontFamily.sansSerif};
  &:last-child {
    border: none;
  }
  @media (${theme.device.sm}) {
    flex-grow: 1;
    flex-basis: 0;
    border-right: 1px solid hsla(240,8%,50%,0.15);
    border-bottom: none;
  }
`;

const CellCenter = styled.div``;

export const Title = styled.div`
  font-size: 1.1em;
  opacity: 0.8;
  &:after {
    content: ':'
;
  }
`;

export const Value = styled.div`
  font-size: 1.75em;
  display: flex;
  vertical-align: text-bottom;
  align-items: baseline;
  white-space: nowrap;
`;

export const ValueSmall = styled.span`
  font-size: 0.5em;
  font-weight: normal;
  &:before {
    content: '('
;
  }
  &:after {
    content: ')'
;
  }
  text-transform: capitalize;
  opacity: 0.5;
`;

export const ValueSeparator = styled.div`
  width: 6px;
  height: 1px;
`;
